import React, { useContext, useRef, useState } from 'react';
import { Box, Container, Paper, IconButton } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import '../styles/css/Intro.css';
import { LanguageContext } from '../App';

const Intro = () => {
  const { language, translations } = useContext(LanguageContext);
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const togglePlay = () => {
    const video = videoRef.current;
    if (!video) return;
    if (video.paused) {
      video.play();
      setIsPlaying(true);
    } else {
      video.pause();
      setIsPlaying(false);
    }
  };

  return (
    <Box className="intro-section" sx={{ py: { xs: 4, md: 8 }, bgcolor: 'background.default' }}>
      <Container maxWidth="lg">
        <Paper 
          elevation={2} 
          sx={{ 
            p: { xs: 3, md: 6 }, 
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(10px)'
          }}
        >
          <p className="intro-title">
            {translations[language].introTitle}
          </p>

          <Box sx={{ maxWidth: '800px', mx: 'auto' }}>
            <p className="intro-subtitle">
              {translations[language].introSubtitle}
            </p>

            <p className="intro-body">
              {translations[language].introBody1}
            </p>
          </Box>
          {/* Add video section below intro text */}
          <Box sx={{ mt: 4, textAlign: 'center' }}>
            <p className="intro-video-label">
              {translations[language].introVideoPlay}
            </p>
            <Box className="intro-video-wrapper" onClick={togglePlay}>
              <video
                ref={videoRef}
                width="100%"
                className="intro-video"
                controls
                poster="/video.png"
                onPlay={() => setIsPlaying(true)}
                onPause={() => setIsPlaying(false)}
                onClick={(e) => e.stopPropagation()}
              >
                <source src="https://studiorami.click/intro.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
              {!isPlaying && (
                <IconButton className="intro-video-play-btn" aria-label="play video">
                  <PlayArrowIcon fontSize="inherit" />
                </IconButton>
              )}
            </Box>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default Intro;
